import { render, staticRenderFns } from "./JSONPreview.vue?vue&type=template&id=259b1a9e"
import script from "./JSONPreview.vue?vue&type=script&lang=js"
export * from "./JSONPreview.vue?vue&type=script&lang=js"
import style0 from "./JSONPreview.vue?vue&type=style&index=0&id=259b1a9e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports